module.exports = __webpack_public_path__ + "src/assets/img/background.d749c05d.png";